/*
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-04-03 09:37:04
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-06-07 11:28:53
 * @FilePath: \合联\oms\src\api\reimburse\apply.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from "@/libs/api.request";
export const getList = (params) => {
  return axios.request({
    url: "/finance/reimburse/createList",
    method: "get",
    params,
  });
};


export const detail = (id) => {
  return axios.request({
    url: "/finance/reimburse/read/" + id,
    method: "get",
  });
};

export const save = (data) => {
  return axios.request({
    url: "/finance/reimburse/create",
    method: "post",
    data
  });
};

export const upload = (data) => {
  return axios.request({
    url: "/finance/reimburse/upload",
    method: "post",
    data
  });
};

export const cancel = (data) => {
  return axios.request({
    url: "/finance/reimburse/cancel/" + data.id,
    method: "post",
    data
  });
};
export const deleteItem = (data) => {
  return axios.request({
    url: "/finance/reimburse/delete/" + data.id,
    method: "post",
    data
  });
};

export const cash = (data) => {
  return axios.request({
    url: "/finance/reimburse/cash",
    method: "post",
    data
  });
};

export const info = (params) => {
  return axios.request({
    url: "/finance/reimburse/info",
    method: "get",
    params,
  });
};

export const amount = (params) => {
  return axios.request({
    url: "/finance/reimburse/amount/" + params.currency_id,
    method: "get",
    params,
  });
};

export const update = (data) => {
  return axios.request({
    url: "/finance/reimburse/update/" + data.id,
    method: "post",
    data
  });
};